import { action } from 'typesafe-actions';

import { AdminActionsEnum } from '../enums/AdminActionsEnum';

export const adminGetSystemInoperabilityList = () => action(AdminActionsEnum.ADMIN_GET_SISTEM_INOPERABILITY_LIST);
export const adminGetSystemInoperabilityListNextPage = () =>
  action(AdminActionsEnum.ADMIN_GET_SISTEM_INOPERABILITY_LIST_NEXT_PAGE);
export const adminSetSystemInoperabilityListOrder = (order: string) =>
  action(AdminActionsEnum.ADMIN_SET_SISTEM_INOPERABILITY_LIST_ORDER, { order });
